import { render, staticRenderFns } from "./allTasks.vue?vue&type=template&id=2c2613c0"
import script from "./allTasks.vue?vue&type=script&lang=js"
export * from "./allTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports